import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { RetorikLogoIcon } from '../Icons/Miscellaneous'

const RetorikLogo = (): JSX.Element => {
  const isUsedOnBorne = useSelector((state: RootState) => state.retorikReducer.configuration.isUsedOnBorne)

  return isUsedOnBorne ? (
    <div className='rf-hidden large:rf-block rf-relative rf-z-[1] ltr:rf-col-start-1 rtl:rf-col-end-1 rf-col-span-full rf-row-start-12 rf-row-span-1 ltr:rf-self-end rtl:rf-self-start rf-justify-self-start'>
      <RetorikLogoIcon className='ltr:rf-ml-4 rtl:rf-mr-4 rf-mb-4 rf-h-14' />
    </div>
  ) : (
    <a
      href='https://davi.ai'
      title='Retorik by Davi'
      target='_blank'
      rel='noreferrer'
      className='rf-hidden large:rf-block rf-relative rf-z-[1] rf-col-start-1 rf-col-span-full rf-row-start-12 rf-row-span-1 rf-self-end rf-justify-self-start'
    >
      <RetorikLogoIcon className='rf-ml-4 rf-mb-4 rf-h-14' />
    </a>
  )
}

export default RetorikLogo
